AddTagView = require 'views/organization/add-tag-view'
EditTagView = require 'views/organization/edit-tag-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
$ = require 'jquery'

t = require('views/internal/teacup-with-helpers')('org_filtering')
template = t.renderable (org, board) ->

  if !org.tagList.models.length
    t.p ->
      t.format 'tags-explanation'

  t.ul '.select-tags-list', ->
    for tag in org.tagList.models
      t.li '.select-tags-list-item.js-tag-item',
        'data-id-tag': tag.id
      , ->
        t.a '.select-tags-list-item-name-link.js-toggle-tag', ->
          if tag.id in board.getIdTags()
            t.icon 'check', class: 'select-tags-list-item-name-link-check-icon'
          t.text tag.get('name')
        t.a '.select-tags-list-item-edit-button.icon-sm.icon-edit.js-edit-tag',
          href: '#'
    return
  t.div ->
    t.a '.quiet-button.full.js-add-tag', href: '#', ->
      t.format 'create-tag'

getIdTag = (e) ->
  $(e.target).closest('.js-tag-item')[0].getAttribute('data-id-tag')

module.exports = class BoardTagSelectView extends View
  initialize: ->
    @listenTo @model, 'change:idTags', @render
    @listenTo @options.org.tagList, 'add remove reset change', @render
    super

  events:
    'click .js-add-tag': 'addTag'
    'click .js-toggle-tag': (e) ->
      @toggleTag getIdTag(e)
    'click .js-edit-tag': (e) ->
      @editTag(e, getIdTag(e))

  viewTitleKey: 'pick tags'

  addTag: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: AddTagView
      options:
        model: @options.org
        modelCache: @modelCache

  toggleTag: (idTag) ->
    @model.toggleTag(idTag)

  editTag: (e, idTag) ->
    Util.stop(e)
    PopOver.pushView
      view: EditTagView
      options:
        modelCache: @modelCache
        model: @options.org.tagList.get(idTag)

  render: ->
    @$el.html template(@options.org, @model)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/board-tag-select-view.coffee